import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { Form, Segment } from 'semantic-ui-react';
import { getAccessInformation, getErrors } from '../reducers/form';
import { updateData } from '../actions/form';

export class AccessInformation extends React.Component {
  render() {
    const { accessInformation, readOnly } = this.props;

    return (
      <Segment>
        <Form.TextArea
          label="Accès (Horaires, contact sur place...)"
          value={accessInformation || ''}
          onChange={this.props.onAccessInformationChange}
          readOnly={readOnly}
        />
      </Segment>
    );
  }
}

AccessInformation.propTypes = {
  accessInformation: PropTypes.string,
  onAccessInformationChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  accessInformation: getAccessInformation(state),
  errors: getErrors(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onAccessInformationChange: (_, change) =>
    dispatch(updateData('zone.accessInformation', change.value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessInformation);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/components/AccessInformation.js